import { Button, Spinner } from 'avo-ui'
import { Section } from 'components/main-page/about-us/section/Section'

export const AboutUs = ({ sectionProps, isLoading, isUpdating, isLoadingUpload, onSubmit }) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <div className={'flex flex-col space-y-6'}>
                        <Section {...sectionProps} name={'section_1'} />
                        <Section {...sectionProps} name={'section_2'} />
                        <Section {...sectionProps} name={'section_3'} />
                    </div>
                    <div className={'flex py-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            loading={isUpdating || isLoadingUpload}
                            title={'Submit'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
